import app from '@/app'

import { Accessor, accessor } from './accessor'

export { accessor } from './accessor'
export { store } from './store'

app.config.globalProperties.$accessor = accessor

// 类型声明
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $accessor: Accessor;
  }
}
